import { render, staticRenderFns } from "./MakerSavings.vue?vue&type=template&id=bc38416a&scoped=true&"
import script from "./MakerSavings.vue?vue&type=script&lang=js&"
export * from "./MakerSavings.vue?vue&type=script&lang=js&"
import style0 from "./MakerSavings.vue?vue&type=style&index=0&id=bc38416a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc38416a",
  null
  
)

export default component.exports